//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('skillsCertificateType', {
//        templateUrl: 'views/components/views/skillsCertificateType/skillsCertificateType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'skillsCertificateTypeService', function ($stateParams, stateService, utilityService, translateService, modalService, skillsCertificateTypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let skillsCertificateTypeKeyno = $stateParams.skillscertificatetype_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                glyphiconButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-left', color: 'primary', type: 'primary', onClick: () => stateService.go('selectglyphicon') }
//                ],
//                edit: {},
//                selectListGlyphicons: [],
//                selectListHexColours: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await skillsCertificateTypeService.getSkillsCertificateType({ skillscertificatetype_keyno: skillsCertificateTypeKeyno }))[0];
//            }

//            async function loadGlyphicons() {
//                vm.model.selectListGlyphicons = await skillsCertificateTypeService.listGlyphicons();
//            }

//            async function loadHexColors() {
//                vm.model.selectListHexColours = await skillsCertificateTypeService.listHexColors();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region SHOW GLYPHICON SYMBOL FUNCTION

//            async function showGlyphiconSymbol() {
//                vm.model.selectListGlyphicons.forEach((glyph) => {
//                    if (vm.model.edit.glyphicon === glyph.item_id) {
//                        vm.model.edit.glyphicon = glyph.item_glyphicon;
//                    }
//                });
//            }

//            // #endregion SHOW GLYPHICON SYMBOL FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'glyphicon':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.glyphicon) !== true) return;

//                        vm.model.edit.glyphicon = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.glyphicon) !== true) return;

//                        showGlyphiconSymbol();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                skillsCertificateTypeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadGlyphicons();
//                loadHexColors();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
